export const MODAL_ACTIONS = {
  ToggleOpen: 'TOGGLE_OPEN',
  ToggleClose: 'TOGGLE_CLOSE',
  ClearData: 'CLEAR_DATA',
};
